const lengthEquals = to => value => value != null && value.length === to;

export default lengthEquals;
